import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-white/80 px-3 py-1.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
      >
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        {current.label}
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-down-s-line text-sm"></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-white py-1">
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-sm font-medium transition-colors hover:bg-background-100 ${
                l.code === current.code ? "text-primary-600" : "text-foreground-700"
              }`}
            >
              {l.label}
              {l.code === current.code && (
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}